"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _Button = _interopRequireDefault(require("@eig-builder/core-ui/Button"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _myImages = require("./my-images");

var _hooks = require("../hooks");

var _controlQuery = require("@eig-builder/control-query");

require("./style/my-logos.scss");

var getEndpoint = function getEndpoint(path, params) {
  var useAppGateway = (0, _runtimeConfigHelper.getRuntimeConfig)()._enableAppGateway || false;

  if (useAppGateway) {
    return (0, _urlHelper.api)(path, 'logos', params);
  } else {
    return (0, _urlHelper.getUrl)(_urlHelper.siteNames.LOGO_API, path, null, params);
  }
};

var getUrlOfLogos = function getUrlOfLogos(path, param) {
  return getEndpoint("/v1.0/".concat(path), param);
};

var MyLogos = function MyLogos(_ref) {
  var toggleLoading = _ref.toggleLoading,
      onUseImages = _ref.onUseImages,
      logoMakerIntegrationUrl = _ref.logoMakerIntegrationUrl;

  var _useActiveView = (0, _hooks.useActiveView)('my-logos'),
      active = _useActiveView.active;

  var getMyLogos = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var url, response, data, dataToJson;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              toggleLoading(true);
              url = getUrlOfLogos('logos/list');
              _context.next = 4;
              return (0, _fetch["default"])(url, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                },
                credentials: 'include'
              });

            case 4:
              response = _context.sent;
              _context.next = 7;
              return response;

            case 7:
              data = _context.sent;
              _context.next = 10;
              return data.json();

            case 10:
              dataToJson = _context.sent;
              return _context.abrupt("return", dataToJson);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getMyLogos() {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useQuery = (0, _controlQuery.useQuery)('myLogos', getMyLogos, {
    refetchOnWindowFocus: false,
    enabled: active
  }),
      logos = _useQuery.data,
      isFetching = _useQuery.isFetching;

  _react["default"].useEffect(function () {
    toggleLoading(isFetching);
  }, [isFetching]);

  if (!active) return null;

  var openLogoMaker = function openLogoMaker() {
    return window.open("".concat(logoMakerIntegrationUrl), '_blank');
  };

  var onImageClick = function onImageClick(index) {
    return onUseImages(logos[index], true);
  };

  if (!isFetching && Array.isArray(logos) && logos.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "logos-loading-message"
    }, /*#__PURE__*/_react["default"].createElement(_myImages.NoImagesBox, null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "imagepicker.noLogosYet"
    }), logoMakerIntegrationUrl && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      tag: "create-button-logo-maker",
      className: "logo-maker-button",
      flat: true,
      onClick: openLogoMaker
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "imagepicker.createLogo"
    }))));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view free-images"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "images"
  }, (logos || []).map(function (logo, i) {
    return logo.preview_image_url && /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "logo-wrapper",
      onClick: function onClick() {
        return onImageClick(i);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "logo-element"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: logo.preview_image_url,
      alt: logo.id
    })));
  })));
};

MyLogos.propTypes = {
  toggleLoading: _propTypes["default"].func,
  onUseImages: _propTypes["default"].func,
  logoMakerIntegrationUrl: _propTypes["default"].any
};

var _default = (0, _withContext["default"])(MyLogos);

exports["default"] = _default;